
class RoleMapping {
    constructor($scope, $state, $mdDialog,localStorageService,authService, $rootScope,ROLESETTINGSCONSTANT) {
        'ngInject';
        this.$state = $state
        $scope.school_id = localStorageService.get('school_id')
        let evaluatorList = [];

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Role Settings"

            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $scope.loadData()

        }
        $scope.loadData=()=>{
            //Evaluator Settings
            authService.callAPI(ROLESETTINGSCONSTANT.API_GET_ALL_ROLE_MAPPING + $scope.school_id, "GET", {}, function (response) {    
                //console.log(response)
                if (response.result != undefined) {
                if (response.result.data && response.result.data.data) {
                    let evaluatorLst=response.result.data.data
                    console.log(evaluatorLst)
                //     if (evaluatorLst != undefined && evaluatorLst.length > 0) {
                //     $scope.evaluatorList = evaluatorLst[0];
                //     $scope.evaluatorRoles = []
                //     if ($scope.evaluatorList != undefined) {
                //         _.each($scope.evaluatorList.details, function(each) {
                //             each.roleArray = [];
                //             var role = _.find($scope.roleList, function(item) {
                //                 return each.head_employee == item._id
                //             })
                //             if (role) {
                //                 each.head_employee_name = role.name;
                //             }

                //             _.each(each.roles, function(obj) {
                //                 var data = _.find($scope.roleList, function(item) {
                //                     return obj == item._id
                //                 })
                //                 each.roleArray.push(data)
                //             })
                //             var obj = {
                //                 "role_id": each.evaluator_role_id,
                //                 "name": each.evaluator_role_name
                //             }
                //             if ($scope.evaluatorRoles.length == 0) {
                //                 $scope.evaluatorRoles.push(obj)
                //             } else {
                //                 let existingObj = _.filter($scope.evaluatorRoles, function(role_obj) {
                //                     return role_obj.role_id === obj.role_id
                //                 })
                //                 if (existingObj.length == 0) {
                //                     $scope.evaluatorRoles.push(obj)
                //                 }
                //             }
                //         })
                //     }
                // }
                if (evaluatorLst != undefined) {
                    $scope.evaluatorList = evaluatorLst.nodes;
                    $scope.evaluatorRoles = []
                    if ($scope.evaluatorList != undefined) {
                    $scope.evaluatorList = _.without($scope.evaluatorList,
                     _.findWhere($scope.evaluatorList, {
                     parent_id: ""}));
                    //console.log($scope.evaluatorList)
                  $scope.evaluatorRoles=_.groupBy($scope.evaluatorList,'parent_id')
        
              }
             
          }
          _.defer(function() {
            $scope.$apply();
        });
            }
        }
    })
        }
        //Role List
        authService.callAPI(ROLESETTINGSCONSTANT.API_GET_ALL_ROLES + $scope.school_id, "GET", {}, function (response) {
            if (response.result != undefined) {
                if (response.result.data && response.result.data.data && response.result.data.data.length > 0) {
                    $scope.roleList = response.result.data.data[0].roles;
                    _.defer(function() {
                        $scope.$apply();
                    });
                }
            }
        })

              
               
          
            // save details of evaluator and roles evaluated by him into 'fpi_evaluator_settings' collection
        $scope.saveRoleMapping = function() {
            var role = _.find($scope.roleList, function(item) {
                return $scope.headEmployee == item._id
            })
            if ($scope.selectedRoles != undefined && $scope.selectedRoles.length > 0) {
                var evaluatorObj = {
                    "school_id": $scope.school_id, //Session.get('school_id'),
                    "details": {
                        "parent_id": $scope.headEmployee,
                        "roles": $scope.selectedRoles,
                        "parent_name": role.name
                    }
                }

            authService.callAPI(ROLESETTINGSCONSTANT.API_SAVE_ROLE_MAPPING, "POST",angular.copy(evaluatorObj), function (response) {
                  if(response.result.data.message==="Success")    
                {
                    toastr.success("Successfully added")
                    $scope.selectedRoles = [];
                    $scope.headEmployee = "";
                    $scope.disableRole = true;
                    $scope.loadData()

                }
                else{
                    toastr.error("Try again")
                }
                _.defer(function() {
                    $scope.$apply();
                });
                })
            } else {
                toastr.error("Select atleast one role")
            }
        }

        //Fixed bug 6303
        $scope.setHeadRole = (item) => {
            $scope.headEmployee = item
            $scope.changedEvaluator($scope.roleList[$scope.roleList.findIndex(i => i._id === item)])
            $scope.$apply()
        }
        $scope.updateRoleMapping = () => {
            var role = _.find($scope.roleList, function(item) {
                    return $scope.headEmployee == item._id
                })
                var evaluatorObj={
                    parent_role:role,
                    role_list:$scope.selectedRoles,
                    school_id:$scope.school_id
                }
                /* if ($scope.selectedRoles != undefined && $scope.selectedRoles.length > 0) {*/
        authService.callAPI(ROLESETTINGSCONSTANT.API_UPDATE_ROLE_MAPPING, "POST",angular.copy(evaluatorObj), function (response) {
            if(response.result.data.message==="Success")
            {
                $scope.disableRole = true;
                $scope.selectedRoles = [];
                $scope.headEmployee = "";
                $scope.evaluatorList = [];
                $scope.showUpdateButton = false;
                toastr.success("Successfully updated")
                $scope.loadData()
            }
            else{
                toastr.error("Try again")
            }
            })
        }

        //calls on evaluator dropdrown in evaluator settings console changed
        $scope.changedEvaluator = (role) => {
            $scope.selectedRoles = []
            $scope.showUpdateButton = false;
            $scope.disableRole = false;
            if ($scope.evaluatorList) {
                var filter = _.filter($scope.evaluatorList, function(each) {
                    return role._id == each.parent_id
                })
                _.each(filter, function(each) {
                    var role = _.find($scope.roleList, function(item) {
                        return each.node_id == item._id
                    })
                    if (role) {
                        $scope.selectedRoles.push(role)
                        $scope.showUpdateButton = true;
                    }
                })
            }
            let reqObj={
                school_id:$scope.school_id,
                role_id:role._id
            }
        authService.callAPI(ROLESETTINGSCONSTANT.API_GET_MAPPED_PARENTS, "POST",reqObj, function (response) {
               if(response.result && response.result.data && response.result.data.data)
               var result = response.result.data.data
            _.each($scope.roleList, function(obj) {
                        obj.isDisable = false
                    })
                    console.log(result)
                    //Fixed QA bug #6315 and #6314
                _.each(result.parentList, function(each) {
                    let index = $scope.roleList.findIndex(i => i._id === each)
                    if (index > -1) {

                        $scope.roleList[index].isHead = true
                        $scope.roleList[index].isDisable = true
                    }

                })
                $scope.$apply()
            })


        }


    }
}
export default RoleMapping;
// const name = 'roleMapping';
// export default angular.module(name, [
//         angularMeteor, uirouter
//     ])
//     .component(name, {
//         templateUrl: 'imports/components/user-management/reporting-roles/reporting-roles-mapping.html',
//         controllerAs: name,
//         controller: RoleMapping
//     })
//     .config(config)

// function config($stateProvider) {
//     'ngInject';
//     $stateProvider.state(name, {
//         url: '/role-mapping',
//         template: '<role-mapping></role-mapping>'
//     })
// }


// WEBPACK FOOTER //
// ./src/app/reporting-roles/controllers/roleSettingsController.js